import { useMutation } from "@tanstack/react-query";
import ApiRequest from "../ApiRequest";
import { requestURLs } from "../../Environment";

export interface LinkAttachmentPayload {
  name: string;
  url: string;
}

export const useTaskLinkAttachmentAddMutation = (
  taskId: string | null | undefined,
) => {
  return useMutation({
    mutationFn: (data: LinkAttachmentPayload) => {
      return ApiRequest.post(`${requestURLs.task}attachment/link/${taskId}`, data);
    },
  });
};


